import request from '@/utils/request'

export const searchListApi = ({ sortType, categoryId, sortPrice, goodsName, page }) => {
  return request.get('/goods/list', {
    params: {
      sortType,
      sortPrice,
      categoryId,
      goodsName,
      page
    }
  })
}
